if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = null;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return; 

      this.handleErrorMessage();
      this.cartNotification = this.cartNotification || document.querySelector('cart-notification');
      if (this.cartNotification && typeof this.cartNotification.setActiveElement === 'function') {
        this.cartNotification.setActiveElement(document.activeElement);
      }

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      const payload = {
        ...JSON.parse(serializeForm(this.form))
      };

      if (this.cartNotification && typeof this.cartNotification.getSectionsToRender === 'function') {
        payload.sections = this.cartNotification.getSectionsToRender().map((section) => section.id);
        payload.sections_url = window.location.pathname;
      }

      config.body = JSON.stringify(payload);

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          if (this.cartNotification && typeof this.cartNotification.renderContents === 'function') {
            this.cartNotification.renderContents(response);
          } else if (window.routes && routes.cart_url) {
            window.location.href = routes.cart_url;
          } else {
            window.location.href = '/cart';
          }
        })
        .catch((e) => {
          this.handleErrorMessage(window.cartStrings?.error || 'Unable to add this item. Please try again.');
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
